import * as d3 from "d3";
import 'bootstrap';
import $ from 'jquery';

d3.select("#btnCloseMCJ")
    .on("click", function () {
        d3.select("#close-mcj-container").style("display", "block");
        d3.select("#overview-container-top").style("display", "none");
        d3.select("#overview-container").style("display", "none");
        d3.select("#race-container").style("display", "none");
        d3.select("#ab109-container").style("display", "none");
        d3.select("#mh-container").style("display", "none");
        d3.select("#population-container").style("visibility", "hidden");
        d3.select("#population-container").style("height", "0px");
        d3.select("#population-container-0").style("display", "none");
        d3.select("#population-container-1").style("display", "none");
        d3.select("#chartType").style("display", "none");
    });
d3.select("#btnOverview")
    .on("click", function () {
        d3.select("#close-mcj-container").style("display", "none");
        d3.select("#overview-container-top").style("display", "block");
        d3.select("#overview-container").style("display", "block");
        d3.select("#race-container").style("display", "none");
        d3.select("#ab109-container").style("display", "none");
        d3.select("#mh-container").style("display", "none");
        d3.select("#population-container").style("visibility", "hidden");
        d3.select("#population-container").style("height", "0px");
        d3.select("#population-container-0").style("display", "none");
        d3.select("#population-container-1").style("display", "none");
        d3.select("#chartType").style("display", "none");
    });
d3.select("#btnPopulation")
    .on("click", function () {
        d3.select("#close-mcj-container").style("display", "none");
        d3.select("#population-container").style("visibility", "visible");
        d3.select("#population-container").style("height", "auto")
        d3.select("#population-container-0").style("display", "block");
        d3.select("#population-container-1").style("display", "block");
        d3.select("#overview-container").style("display", "none");
        d3.select("#overview-container-top").style("display", "none");
        d3.select("#race-container").style("display", "none");
        d3.select("#mh-container").style("display", "none");
        d3.select("#chartType").style("display", "none");
        d3.select("#ab109-container").style("display", "none");
    });
d3.select("#btnRace")
    .on("click", function () {
        d3.select("#close-mcj-container").style("display", "none");
        d3.select("#overview-container").style("display", "none");
        d3.select("#overview-container-top").style("display", "none");
        d3.select("#race-container").style("display", "block");
        d3.select("#chartType").style("display", "block");
        d3.select("#mh-container").style("display", "none");
        d3.select("#ab109-container").style("display", "none");
        d3.select("#population-container").style("visibility", "hidden");
        d3.select("#population-container").style("height", "0px");
        d3.select("#population-container-0").style("display", "none");
        d3.select("#population-container-1").style("display", "none");
    });

d3.select("#btnMH")
    .on("click", function () {
        d3.select("#close-mcj-container").style("display", "none");
        d3.select("#mh-container").style("display", "block");
        d3.select("#chartType").style("display", "block");
        d3.select("#race-container").style("display", "none");
        d3.select("#overview-container").style("display", "none");
        d3.select("#overview-container-top").style("display", "none");
        d3.select("#ab109-container").style("display", "none");
        d3.select("#population-container").style("visibility", "hidden");
        d3.select("#population-container").style("height", "0px");
        d3.select("#population-container-0").style("display", "none");
        d3.select("#population-container-1").style("display", "none");
    });

d3.select("#btnAB")
    .on("click", function () {
        d3.select("#close-mcj-container").style("display", "none");
        d3.select("#ab109-container").style("display", "block");
        d3.select("#race-container").style("display", "none");
        d3.select("#overview-container").style("display", "none");
        d3.select("#overview-container-top").style("display", "none");
        d3.select("#mh-container").style("display", "none");
        d3.select("#population-container").style("visibility", "hidden");
        d3.select("#population-container").style("height", "0px");
        d3.select("#population-container-0").style("display", "none");
        d3.select("#population-container-1").style("display", "none");
        d3.select("#chartType").style("display", "none");
    });

$(".button").on('click', function () {
    $(".button").not(this).removeClass('active');
    $(this).addClass('active');
    window.dispatchEvent(new Event('resize'));

    if ('parentIFrame' in window) window.parentIFrame.autoResize(true); return false;
});